import { render, staticRenderFns } from "./NewTransfers.vue?vue&type=template&id=3b38b716&scoped=true&"
import script from "./NewTransfers.vue?vue&type=script&lang=js&"
export * from "./NewTransfers.vue?vue&type=script&lang=js&"
import style0 from "./NewTransfers.vue?vue&type=style&index=0&id=3b38b716&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b38b716",
  null
  
)

export default component.exports